import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'components/Shared/Toast';
import { utils } from 'ethers'
import {
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Button,
    Spinner,
    FormGroup,
    Input,
    Label,
    FormFeedback
} from 'reactstrap';

import useMetamask from 'hooks/useMetamask';

const initialStatus = { value: '', isValid: false, isEndorsing: false, isTouched: false };

const validateSameAddress = (x = '', y = '') => x.toLowerCase() === y.toLowerCase();

function EndorsePagare({ toggle, isOpen, pagareId, contractId, jwt, acreedor }) {

    const { t } = useTranslation();
    const [state, setState] = useState({ ...initialStatus });

    const { endorseToken, isEndorsing } = useMetamask(process.env.REACT_APP_PAGARE_ADDRESS, contractId, pagareId, jwt);

    const onSubmit = async () => {
        if (!state.isValid) return;

        setState({ ...state, isEndorsing: true });

        endorseToken(state.address)
            .then((mutation) => {
                if (mutation) {
                    toast.success(t('common.success'))
                }
            }).catch((error) => {
                toast.error(t(`errors.${error.message}`))
            }).finally(() => {
                toggle();
                setState({ ...initialStatus });
            })

    }

    const handleChange = (e) => {
        const value = e.target.value;
        setState({
            isTouched: true,
            address: value,
            isValid: utils.isAddress(value),
            isSameAddress: validateSameAddress(acreedor, value)
        })
    }

    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader toggle={toggle}>
                {t('blockchain.endorse_promissory_note')}
            </ModalHeader>
            <ModalBody className="text-center">
                <Form>
                    <FormGroup>
                        <Label for="endorse-input">{t('blockchain.new_owner_name')}</Label>
                        <Input
                            disabled={state.isEndorsing}
                            name="newOwnerName"
                            onChange={handleChange}
                            className="text-center"
                            id="endorse-input"
                            invalid={(state.isSameAddress || !state.isValid) && state.isTouched}
                            placeholder={t('blockchain.new_owner_name')}
                        />
                        <FormFeedback hidden={!state.isTouched}>{t('errors.InvalidAddress')}</FormFeedback>
                        <FormFeedback hidden={!state.isSameAddress}>{t('blockchain.isSameAddress')}</FormFeedback>
                    </FormGroup>
                    <Button
                        block
                        color="primary"
                        onClick={onSubmit}
                        disabled={state.isEndorsing || !state.isValid || state.isSameAddress}
                        id="endorse-button"
                    >
                        <Spinner hidden={!isEndorsing} size="sm" />
                        {' '}{t('blockchain.endorse')}
                    </Button>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default EndorsePagare